import {BrickContext, Brick, registerBrick } from 'olympe';

export default class IsArray extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} object
     * @param {function(boolean)} setIsArray
     * @param {function(Array)} setArray
     */
    update($, [object], [setIsArray, setArray]) {
        if (Array.isArray(object)) {
            setIsArray(true);
            setArray(object);
        } else {
            setIsArray(false);
            setArray(null);
        }
    }
}

registerBrick('01928ef395b964b484f7', IsArray);
